import type { ProfileLeaderboard, UserData } from '../../../types';

export enum CampaignType {
  TRANSACTION = 'transaction',
  VOLUME = 'volume',
}

export type PropTypes = {
  campaignId: string;
  userData: UserData | null;
  leaderboardData: ProfileLeaderboard[] | null;
  leaderboardLoading: boolean;
  leaderboardTotalPages: number | null;
  page: number;
  handlePageNavigation: (pageNumber: number) => void;
  type?: CampaignType;
  tooltip?: string;
};
